var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qrcode"},[(_vm.iconurl==='0'?false:true)?_c('img',{staticClass:"logoimg",style:(_vm.imgstyle),attrs:{"src":_vm.iconurl}}):_vm._e(),_c('div',{ref:'qrCodeUrl'+_vm.id,attrs:{"id":'qrcode'+_vm.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }